import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="form-succes-message"
// Intercepta el submit y envia via fetch(), mostrando un flash message
// cuando el server responde { status: 'ok' }.
export default class extends Controller {
  static values = {
    text: String,
    subtitle: { type: String, default: 'Enseguida te contactará uno de nuestros asesores para empezar a trabajar en tu caso.' },
    style: { type: String, default: 'rnk-Flash-success' }
  }
  static targets = ['replace']

  connect () {
    this.element.addEventListener('submit', (event) => {
      event.preventDefault()
      this.enviarFormulario()
    })
  }

  enviarFormulario () {
    const form = this.element.tagName === 'FORM' ? this.element : this.element.querySelector('form')
    this.sincronizarTelefono(form)
    this.normalizarInputsConFormatoLocal(form)
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(form.action, {
      method: form.method,
      headers: { 'X-CSRF-Token': csrfToken, 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(response => response.json())
      .then(data => {
        if (data.status === 'ok') this.mostrarFlash()
      })
      .catch(() => {})
  }

  // `int-local-format` muestra el número con separador de miles ("200.000"). Como enviamos
  // via fetch + FormData (sin submit nativo), hay que devolver cada input a su originalValue()
  // antes de construir el FormData, o el backend recibiría "200.000" (mismo patrón que
  // `normalizeIntLocalFormatInputs` en multistep-wizard-hipotecas.js).
  normalizarInputsConFormatoLocal (form) {
    form.querySelectorAll('input[is="int-local-format"]').forEach(input => {
      if (typeof input.originalValue === 'function') input.value = input.originalValue()
    })
  }

  sincronizarTelefono (form) {
    const prefijo = form.querySelector('[name$="[telefono_prefijo]"]')
    const numero = form.querySelector('[name$="[telefono_numero]"]')
    const telefono = form.querySelector('[name$="[telefono]"]')
    if (prefijo && numero && telefono) {
      telefono.value = prefijo.value + numero.value
    }
  }

  mostrarFlash () {
    const flash = document.createElement('div')
    const formContent = this.element.querySelector('.rnk-WidgetHipotecas_FormContent')

    if (formContent) {
      flash.classList.add('rnk-FormSuccessMessage')
      const subtitleHtml = this.subtitleValue ? `<p class="rnk-FormSuccessMessage_Subtitle">${this.subtitleValue}</p>` : ''
      flash.innerHTML = [
        '<svg class="rnk-FormSuccessMessage_Icon" width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg">',
        '<circle cx="28" cy="28" r="23" fill="white" stroke="#4CAF50" stroke-width="5"/>',
        '<path d="M17 29L25 37L40 20" stroke="#4CAF50" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/>',
        '</svg>',
        '<div>',
        `<strong class="rnk-FormSuccessMessage_Title">${this.textValue}</strong>`,
        subtitleHtml,
        '</div>'
      ].join('')
      formContent.replaceWith(flash)
    } else {
      flash.classList.add(...this.styleValue.split(' '))
      flash.textContent = this.textValue
      this.element.insertAdjacentElement('afterend', flash)
      setTimeout(() => flash.remove(), 4000)
    }
  }
}
